import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { StorageService } from '../../store/storage/storage.service';

@Injectable()
export class HandleGlobalErrorService implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: any): void {
    const unwrapped = error?.rejection || error;
    if (unwrapped instanceof HttpErrorResponse && unwrapped.status === 401) {
      const router = this.injector.get(Router);
      if (!router.url.startsWith('/auth/')) {
        this.injector.get(StorageService).clearAuthSession();
        router.navigateByUrl('/auth/login');
      }
      return;
    }
    console.error(error);
  }
}  